import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useShutdownAlisaStateChange } from '../../changeAlisaState';
import { useGenerateAlisaAudio } from '../../generateAlisaAudio';
import { useAddShutdonwAttachments } from '../../addAttachments';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { setValueNewShutdown } from '../../../filterNew/model/actions';

const createShutdown = async (values) => {
  const { files, enableAlisa, company, mainInitiator, ...restValues } = values;

  const data = await request.post(
    `/Alert`,
    restValues,
    'Не удалось создать отключение'
  );

  return data;
};

export const useCreateShutdown = (options = {}) => {
  const { add: addAttachments } = useAddShutdonwAttachments();
  const { generateAudio } = useGenerateAlisaAudio();
  const { change: alisaStateChange } = useShutdownAlisaStateChange();
  const dispatch = useDispatch();

  const createMutation = useMutation(({ values }) => createShutdown(values), {
    ...options,
    onSuccess: async (data, { values }) => {
      if (data?.id) {
        const { files, alisaText, enableAlisa } = values;

        if (files) {
          await addAttachments({ shutdownId: data.id, files });
        }

        if (alisaText) {
          await generateAudio({
            shutdownId: data.id,
            text: alisaText,
          });
        }

        if (enableAlisa === true) {
          await alisaStateChange({ shutdownId: data.id, data: enableAlisa });
        }

        dispatch(setValueNewShutdown(data.id));

        if (typeof options.onSuccess === 'function') {
          options.onSuccess();
        }

        dispatch(fetchShutdownsThunk());
      }
    },
  });

  const create = (values) => createMutation.mutateAsync({ values });

  return {
    create,
    loading: createMutation.isLoading,
  };
};
